import React from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import logoImage from '../../assets/image/logo_cs.png';
import logoFacebook from '../../assets/image/socialmedia/facebook.png';
import logoLinkedin from '../../assets/image/socialmedia/linkedin.png';
import logoTwitter from '../../assets/image/socialmedia/twitter.png';
import logoYoutube from '../../assets/image/socialmedia/youtube.png';
import TooltipButton from '../shared/TooltipButton';
import Tr from '../shared/tr';

interface AboutDlgProps {
  open: boolean;
  onClose: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '640px',
      VerticalAlign: 'text-bottom',
      textAlign: 'center',
      AlignItems: 'center',
      marginTop: '12px',
    },
    logo: {
      width: 32,
      AlignItems: 'center',
    },
    link_button: {
      marginLeft: '12px',
      height: 40,
      '& img': { width: 32, height: 32 },
    },
    link_group: {
      display: 'flex',
      flexDirection: 'row',
      AlignItems: 'center',
      justifyContent: 'center',
    },
    btn: {
      margin: 'auto',
      marginBottom: 20,
      textTransform: 'none',
      background: '#E2F8FC',
      color: '#000000',
      '&:hover': {
        background: '#36B0C9',
        color: '#ffffff',
      },
      minWidth: 80,
      minHeight: 32,
    },
  })
);

function AboutDlg(props: AboutDlgProps) {
  const classes = useStyles();
  const year = new Date().getFullYear();
  const tr = new Tr();
  return (
    <Dialog open={props.open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle>{tr.titlebarAbout()}</DialogTitle>

      <DialogContent>
        <div className={classes.root}>
          <img src={logoImage} className={classes.logo} />
          <Typography gutterBottom variant="subtitle2">
            CS WebViewer
          </Typography>
        </div>
        <div className={classes.root}>
          <Typography gutterBottom variant="body2">
            {tr.aboutDlgProductVersion()} {process.env.REACT_APP_VERSION}
          </Typography>
        </div>
        <div className={classes.root}>
          <Typography gutterBottom variant="body2">
            {/* © {year} Carestream Dental LLC. All Rights Reserved */}
            {tr.aboutDlgRightNotice(year)}
          </Typography>
        </div>

        <div className={classes.root}>
          <Divider variant="middle" />
        </div>

        <div className={classes.root}>
          <Typography gutterBottom variant="subtitle2">
            {tr.aboutDlgFollowUS()}
          </Typography>
        </div>

        <div className={classes.link_group}>
          <TooltipButton
            title={tr.aboutDlgCSDonSocialMedia('Facebook')}
            imgSrc={logoFacebook}
            className={classes.link_button}
            onClick={() => {
              window.open('https://www.facebook.com/CarestreamDental?ref=ts');
            }}
          ></TooltipButton>

          <TooltipButton
            title={tr.aboutDlgCSDonSocialMedia('Twitter')}
            imgSrc={logoTwitter}
            className={classes.link_button}
            onClick={() => {
              window.open('https://twitter.com/CarestreamDentl');
            }}
          ></TooltipButton>

          <TooltipButton
            title={tr.aboutDlgCSDonSocialMedia('LinkedIn')}
            imgSrc={logoLinkedin}
            className={classes.link_button}
            onClick={() => {
              window.open('https://www.linkedin.com/company/carestream-dental/');
            }}
          ></TooltipButton>

          <TooltipButton
            title={tr.aboutDlgCSDonSocialMedia('Youtube')}
            imgSrc={logoYoutube}
            className={classes.link_button}
            onClick={() => {
              window.open('https://www.youtube.com/user/CarestreamDental');
            }}
          ></TooltipButton>
        </div>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => {
            props.onClose();
          }}
          color="primary"
          className={classes.btn}
          autoFocus
        >
          {tr.generalOK()}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AboutDlg;
